import styles from "./index.module.scss";
import Image from "next/image";

export default function DepositFooter() {
  return (
    <div className={styles.depositIcons}>
      <Image
        width={50}
        height={50}
        src="/images/mcsc.svg"
        alt="deposit Option 1"
        className={styles.depositIcon}
      />
      <Image
        width={50}
        height={50}
        src="/images/pci.svg"
        alt="deposit Option 2"
        className={styles.depositIcon}
      />
      <Image
        width={50}
        height={50}
        src="/images/secure.svg"
        alt="deposit Option 3"
        className={styles.depositIcon}
      />
      <Image
        width={50}
        height={50}
        src="/images/vbv.svg"
        alt="deposit Option 4"
        className={styles.depositIcon}
      />
    </div>
  );
}
